/* Quiétou — fiche produit : choix Taille + Couleur, prix, photo du coloris, galerie, barre d'achat mobile. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.qtReady) return;
    root.dataset.qtReady = '1';

    var dataEl = root.querySelector('[data-qt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.querySelector('[data-qt-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atc = root.querySelector('[data-qt-atc]');
    var atcLabel = atc ? atc.getAttribute('data-label') : '';
    var priceEls = root.querySelectorAll('[data-qt-price]');
    var sizeOut = root.querySelector('[data-qt-size-out]');
    var colorOut = root.querySelector('[data-qt-color-out]');
    var hints = root.querySelectorAll('[data-qt-hint]');
    var stickyLabel = root.querySelector('[data-qt-sticky-label]');
    var sticky = root.querySelector('[data-qt-sticky]');
    var slides = root.querySelectorAll('[data-qt-slide]');
    var thumbs = root.querySelectorAll('[data-qt-thumb]');
    var colorThumbImgs = root.querySelectorAll('[data-qt-thumb-color]');

    function checked(name) {
      var el = root.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function findVariant(size, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.size === size && v.color === color) return v;
      }
      return null;
    }

    function showSlide(key) {
      for (var i = 0; i < slides.length; i++) {
        slides[i].hidden = slides[i].getAttribute('data-qt-slide') !== key;
      }
      var thumbKey = key.indexOf('color:') === 0 ? 'color' : key;
      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].setAttribute('aria-current', thumbs[j].getAttribute('data-qt-thumb') === thumbKey ? 'true' : 'false');
      }
    }

    function currentColorKey() {
      var c = checked('qt-color');
      return 'color:' + (c || '');
    }

    function update(fromColorChange) {
      var size = checked('qt-size');
      var color = checked('qt-color');
      var v = findVariant(size, color);

      if (sizeOut && size) sizeOut.textContent = size;
      if (colorOut && color) colorOut.textContent = color;
      for (var h = 0; h < hints.length; h++) {
        hints[h].hidden = hints[h].getAttribute('data-qt-hint') !== size;
      }

      if (v) {
        if (idInput) idInput.value = v.id;
        for (var p = 0; p < priceEls.length; p++) priceEls[p].textContent = v.price;
        if (atc) {
          atc.disabled = !v.available;
          atc.textContent = v.available ? atcLabel : atc.getAttribute('data-soldout');
        }
        if (stickyLabel) stickyLabel.textContent = size + ' · ' + v.price;
        if (window.history && window.history.replaceState && root.hasAttribute('data-qt-url')) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* URL non modifiable : sans effet sur l'achat */ }
        }
      } else if (atc) {
        atc.disabled = true;
        atc.textContent = atc.getAttribute('data-unavailable');
      }

      for (var c = 0; c < colorThumbImgs.length; c++) {
        colorThumbImgs[c].hidden = colorThumbImgs[c].getAttribute('data-qt-thumb-color') !== color;
      }
      if (fromColorChange) showSlide(currentColorKey());
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === 'qt-size') update(false);
      if (t.name === 'qt-color') update(true);
    });

    for (var k = 0; k < thumbs.length; k++) {
      thumbs[k].addEventListener('click', function () {
        var key = this.getAttribute('data-qt-thumb');
        showSlide(key === 'color' ? currentColorKey() : key);
      });
    }

    // Barre d'achat mobile : visible quand le bouton principal sort de l'écran.
    if (sticky) {
      sticky.inert = true;
      sticky.setAttribute('aria-hidden', 'true');
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.setAttribute('data-visible', show ? 'true' : 'false');
        sticky.inert = !show;
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(atc);
      var stickyBtn = sticky.querySelector('[data-qt-sticky-submit]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (atc.disabled) return;
          if (form.requestSubmit) form.requestSubmit(atc); else form.submit();
        });
      }
    }

    update(false);

    // Précharge les photos des autres coloris une fois la page chargée : le changement de coloris devient instantané.
    function preloadColors() {
      var imgs = root.querySelectorAll('[data-qt-slide^="color:"] img');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }
    if (document.readyState === 'complete') setTimeout(preloadColors, 1500);
    else window.addEventListener('load', function () { setTimeout(preloadColors, 1500); });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-qt-pdp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
